import { ThemeProvider } from 'styled-components';
import { GetStaticPropsResult } from 'next';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { BrowsableMenu } from '@maverick/cms';
import { OutbackTheme } from '@maverick/themes';
import { BrowsableMenuPageProps, getEmptyNavigationItems, GetHeader, REVALIDATE_DELAY } from 'src/utils/Utils';
import { dictionaryServiceFactory } from 'lib/dictionary-service-factory';
import { Config } from 'src/Config';
import { GetNavigationItems } from '@maverick/sitecore';
import { ToastProvider } from '@maverick/ui';

export async function getStaticProps(
    context: BrowsableMenuPageProps
): Promise<GetStaticPropsResult<BrowsableMenuPageProps>> {
    const params = context.params;

    try {
        const dictionaryService = dictionaryServiceFactory.create(Config.Brand);
        const dictionaryPromise = dictionaryService.fetchDictionaryData('en');
        const [dictionary] = await Promise.all([dictionaryPromise]);

        return {
            props: {
                params: {
                    ...params,
                    items: await GetNavigationItems(Config.Brand),
                    dictionary: dictionary,
                    auth0Config: Config.Auth0,
                },
            },
            revalidate: REVALIDATE_DELAY,
        };
    } catch (error) {
        return {
            props: {
                params: {
                    ...params,
                    items: getEmptyNavigationItems(),
                    dictionary: null,
                    auth0Config: Config.Auth0,
                },
            },
            revalidate: REVALIDATE_DELAY,
        };
    }
}

const MenuPage = (props: BrowsableMenuPageProps): React.JSX.Element => {
    const router = useRouter();
    const publicUrl = Config.Urls.Cms;
    const params = props.params;

    return (
        <ThemeProvider theme={OutbackTheme}>
            <ToastProvider>
                <Head>
                    <title>Outback Steakhouse Menu</title>
                    <meta
                        name='description'
                        content="View the full Outback Steakhouse menu. Steaks, ribs, seafood, Bloomin' Onion & more. See prices, nutrition info, and order online."
                    />
                    <link rel='icon' href={`${publicUrl}/favicon.ico`} />
                    <link rel='canonical' href={`${publicUrl}/menu`} />
                </Head>
                {GetHeader(params.items, params.auth0Config)}
                <div style={{ minHeight: 'calc(100vh - 100px)', backgroundColor: '#E5C8A2' }}>
                    <BrowsableMenu router={router}></BrowsableMenu>
                </div>
            </ToastProvider>
        </ThemeProvider>
    );
};

export default MenuPage;
